import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import AppAppBar from "../components/landing/AppAppBar";
import Hero from "../components/landing/Hero";
import Features from "../components/landing/Features";
import Highlights from "../components/landing/Highlights";
import Pricing from "../components/landing/Pricing";
import Testimonials from "../components/landing/Testimonials";
import FAQ from "../components/landing/FAQ";
import Footer from "../components/landing/Footer";
import { CALENDLY_URL } from "../utils/calendly";

export default function LandingPage() {
  return (
    <>
      <CssBaseline enableColorScheme />
      <AppAppBar />
      <Hero />
      {/* Hidden inline widget -- loads Calendly data in background so popup opens instantly */}
      <div
        className="calendly-inline-widget"
        data-url={CALENDLY_URL}
        style={{
          position: "fixed",
          width: 1,
          height: 1,
          overflow: "hidden",
          opacity: 0,
          pointerEvents: "none",
          zIndex: -1,
        }}
      />
      <div>
        <Features />
        <Divider />
        <Testimonials />
        <Divider />
        <Highlights />
        <Divider />
        <Pricing />
        <Divider />
        <FAQ />
        <Divider />
        <Footer />
      </div>
    </>
  );
}
